var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wecoupon-mall-list-fail"},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"tips"},[_vm._v(_vm._s(_vm.i18n('获取商圈下券信息失败，请重试')))]),_c('FitButton',{attrs:{"type":"default"},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.i18n('重试')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }